/* Échiquier Boutique — finitions (Claude, 2e passe). Aucune dépendance. */
(function () {
  'use strict';
  function ready(fn) { if (document.readyState !== 'loading') { setTimeout(fn, 0); } else { document.addEventListener('DOMContentLoaded', function () { setTimeout(fn, 0); }); } }
  var fr = (document.documentElement.lang || 'fr').indexOf('fr') === 0;
  var root = fr ? '' : '/en';
  var body = document.body;

  /* 1. Menu téléphone : liens utiles sous les catégories */
  function drawerLinks() {
    var ul = document.querySelector('#NavDrawer ul.drawer__nav');
    if (!ul || document.querySelector('.eb-drawer-extra')) { return; }
    var links = fr ? [
      ['Jeux d’échecs électroniques', '/collections/jeux-echecs-electroniques', 1],
      ['Meilleures ventes', '/collections/meilleures-ventes', 1],
      ['Le blog des échecs', '/blogs/echecs', 0],
      ['Livraison', '/pages/politique-livraison', 0],
      ['Questions fréquentes', '/pages/faq', 0],
      ['Contact', '/pages/contact', 0]
    ] : [
      ['Electronic chess sets', '/collections/jeux-echecs-electroniques', 1],
      ['Best sellers', '/collections/meilleures-ventes', 1],
      ['Chess blog', '/blogs/echecs', 0],
      ['Shipping', '/pages/politique-livraison', 0],
      ['FAQ', '/pages/faq', 0],
      ['Contact', '/pages/contact', 0]
    ];
    var box = document.createElement('div');
    box.className = 'eb-drawer-extra';
    links.forEach(function (l) {
      var a = document.createElement('a');
      a.href = root + l[1];
      a.textContent = l[0];
      if (l[2]) { a.className = 'eb-drawer-strong'; }
      box.appendChild(a);
    });
    ul.parentNode.insertBefore(box, ul.nextSibling);
  }

  /* 2. Bulle de discussion : icône seule sur téléphone, pour ne plus recouvrir le contenu */
  function compactChat() {
    if (window.innerWidth > 749) { return; }
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      try {
        var sc = document.querySelector('shopify-chat');
        var rt = sc && sc.shadowRoot && sc.shadowRoot.querySelector('shopify-agent-runtime');
        var sr = rt && rt.shadowRoot;
        if (sr && sr.querySelector('button.activator')) {
          if (!sr.querySelector('#eb-chat-style')) {
            var s = document.createElement('style');
            s.id = 'eb-chat-style';
            s.textContent = '.activator__label{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip:rect(0 0 0 0)!important;white-space:nowrap!important}.activator{min-width:0!important;gap:0!important}';
            sr.appendChild(s);
          }
          clearInterval(timer);
        }
      } catch (e) {}
      if (tries > 40) { clearInterval(timer); }
    }, 500);
  }

  /* 3. Fiche produit */
  function productPage() {
    if (!body.classList.contains('template-product')) { return; }
    /* lien vers le guide des tailles */
    var labels = document.querySelectorAll('.selector-wrapper label');
    Array.prototype.forEach.call(labels, function (lab) {
      if (/^(taille|size)/i.test(lab.textContent.trim()) && !lab.querySelector('.eb-size-guide')) {
        var a = document.createElement('a');
        a.className = 'eb-size-guide';
        a.href = root + '/blogs/acheter-jeu-echec/comment-choisir-la-taille-de-son-jeu-echecs';
        a.textContent = fr ? 'Quelle taille choisir ?' : 'Which size to choose?';
        lab.appendChild(a);
      }
    });
    /* prix rappelé dans le bouton d'achat fixe (téléphone) */
    var btnText = document.querySelector('#sedoncaddtocartbtn .btn__text');
    var price = document.querySelector('.product-single__price');
    if (btnText && price) {
      var base = btnText.textContent.replace(/\s+/g, ' ').trim();
      var upd = function () {
        var p = price.textContent.replace(/\s+/g, ' ').trim();
        btnText.textContent = p ? base + ' · ' + p : base;
      };
      upd();
      if (window.MutationObserver) { new MutationObserver(upd).observe(price, { childList: true, subtree: true, characterData: true }); }
    }
    /* encart d'aide : ajout du SMS */
    var help = document.querySelector('.eb-pdp-help');
    if (help && fr) {
      help.innerHTML = 'Une question avant de commander ? <a href="/pages/contact">Écrivez-nous</a> ou envoyez un SMS au <a href="sms:+33626838681">06 26 83 86 81</a> : réponse sous 24 h ouvrées.';
    }
    /* tableau des caractéristiques : même présentation sur toutes les fiches */
    var lists = document.querySelectorAll('.product-single__description ul');
    Array.prototype.forEach.call(lists, function (ul) {
      var items = ul.children;
      if (items.length < 3) { return; }
      for (var i = 0; i < items.length; i++) {
        var first = items[i].firstElementChild;
        if (!first || !/:\s*$/.test(first.textContent)) { return; }
      }
      ul.classList.add('eb-specs');
      Array.prototype.forEach.call(items, function (li) {
        if (li.children.length === 1) {
          var span = document.createElement('span');
          while (li.childNodes.length > 1) { span.appendChild(li.childNodes[1]); }
          li.appendChild(span);
        }
      });
    });
  }

  /* 4. Collections sur téléphone : raccourcis vers les autres rayons */
  function chips() {
    if (!body.classList.contains('template-collection') || window.innerWidth > 749) { return; }
    var h1 = document.querySelector('#MainContent h1');
    if (!h1 || document.querySelector('.eb-chips')) { return; }
    var cats = fr ? [
      ['Bois', 'jeux-echecs-bois'], ['Électroniques', 'jeux-echecs-electroniques'], ['Luxe', 'jeux-echecs-luxe'], ['Voyage', 'jeux-echecs-voyage'], ['Magnétiques', 'jeux-echecs-magnetiques'], ['Échiquiers', 'echiquiers-bois'], ['Pièces', 'pieces-echecs'], ['Pendules', 'pendules-echecs'], ['Meilleures ventes', 'meilleures-ventes']
    ] : [
      ['Wood', 'jeux-echecs-bois'], ['Electronic', 'jeux-echecs-electroniques'], ['Luxury', 'jeux-echecs-luxe'], ['Travel', 'jeux-echecs-voyage'], ['Magnetic', 'jeux-echecs-magnetiques'], ['Boards', 'echiquiers-bois'], ['Pieces', 'pieces-echecs'], ['Clocks', 'pendules-echecs'], ['Best sellers', 'meilleures-ventes']
    ];
    var ul = document.createElement('ul');
    ul.className = 'eb-chips';
    var path = location.pathname;
    cats.forEach(function (c) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = root + '/collections/' + c[1];
      a.textContent = c[0];
      if (path.indexOf('/collections/' + c[1]) !== -1) { a.className = 'is-active'; }
      li.appendChild(a);
      ul.appendChild(li);
    });
    h1.parentNode.insertBefore(ul, h1);
  }

  ready(function () {
    try { drawerLinks(); } catch (e) {}
    try { compactChat(); } catch (e) {}
    try { productPage(); } catch (e) {}
    try { chips(); } catch (e) {}
  });
})();
